module.exports = __webpack_public_path__ + "static/media/humanGroup.ee87de2d.svg";